import React, { useState } from "react";
import { CONTINENTS, CATEGORY_META } from "../data/constants";
import WorldMap from "../components/WorldMap";

export default function GuidesPage({ go, initialCont, initialCategory }) {
  const [cont, setCont] = useState(initialCont || "All");
  const [search, setSearch] = useState("");
  const [showPins, setShowPins] = useState(false);
  const [showChoropleth, setShowChoropleth] = useState(false);
  const [category, setCategory] = useState(initialCategory || "All");

  return (
    <div className="gp" style={{ maxWidth: "100%" }}>
      <h1>Guides</h1>
      <p>Click any country to view its highpoint guide. Hover a country to see its peak location. Select a continent to zoom in.</p>
      <div className="ct">
        {CONTINENTS.map((c) => (
          <button key={c} className={`ctb ${cont === c ? "a" : ""}`} onClick={() => setCont(c)}>{c}</button>
        ))}
        <button
          className={`ctb pins-toggle ${showPins ? "a" : ""}`}
          onClick={() => setShowPins(!showPins)}
        >
          📍 {showPins ? "Hide" : "Show"} All Peaks
        </button>
        <button
          className={`ctb choropleth-toggle ${showChoropleth ? "a" : ""}`}
          onClick={() => setShowChoropleth(!showChoropleth)}
        >
          🗺 {showChoropleth ? "Hide" : "Show"} Elevation Map
        </button>
        <select
          value={category}
          onChange={(e) => setCategory(e.target.value)}
          style={{ marginLeft: 8, padding: "4px 8px", borderRadius: 6, border: "1px solid var(--brd)", background: "var(--card)", color: "var(--t1)", fontSize: 13, cursor: "pointer" }}
        >
          <option value="All">All Types</option>
          {Object.keys(CATEGORY_META).map((cat) => (
            <option key={cat} value={cat}>{CATEGORY_META[cat].label}</option>
          ))}
        </select>
      </div>
      <div className="sb">
        <input placeholder="Search countries or peaks..." value={search} onChange={(e) => setSearch(e.target.value)} />
      </div>
      <WorldMap onSelect={(code) => go({ t: "detail", code, from: "guides", ...(cont !== "All" && { filter: cont }), ...(category !== "All" && { category }) })} cont={cont} search={search} showAllPins={showPins} choropleth={showChoropleth} category={category} />
    </div>
  );
}
